import { render } from "./CustomerDashboardPage.vue?vue&type=template&id=4da617f8"
import script from "./CustomerDashboardPage.vue?vue&type=script&lang=js"
export * from "./CustomerDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__